import React from 'react';

export class ReturnForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      type: null,
      selectedRetailer: ''
    };

    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  handleSelectChange(event) {
    this.setState({selectedRetailer: event.target.value});
  }

  handleReturnClick() {
    window.ga && window.ga('send', 'event', 'new store locator', 'returns click', this.props.store.id);
    window.location.href = this.state.selectedRetailer ?
      `/returns/${this.state.selectedRetailer}?postcode=${this.props.postcode}` :
      '/returns';
  }

  handleClick = () => {
    if (this.state.type === null) {
      this.setState({type:'return'});
    } else {
      this.setState({type: null});
    }
  }

  render() {
    return (
      <div style={{display: "flex", flexDirection: "row", gap: 24, marginBottom: "5%"}}>
        { this.props.directionUrl &&
          <button
            className="outlined-secondary"
            style={{cursor: "pointer"}}
            onClick={() => window.open(this.props.directionUrl, "_blank")}
          >
            Get directions
          </button>
        }

        <div className="return-a-parcel-link-wrapper">
          <button
            className={`outlined-secondary ${this.props.store.store_type === "PaypointStore" ? "-store" : "-locker"}`}
            style={{cursor: "pointer"}}
            onClick={() => (window.location.href = "/returns")}
          >
            Return a parcel
          </button>
        </div> 
      </div>
    );
  }
}
